import React from "react"
import Navbar from "./Navbar"
import Searchbar from "./Searchbar"
import Dashboard from "./Dashboard"
const Main = () => {
  return (
    <main>
      <Navbar />
      <Searchbar />
      <Dashboard />
    </main>
  )
}

export default Main
